import styled from 'styled-components';
import store from '@/store';
import { colors } from '@/globalStyles';
import { SMARTPHONE } from '@/constants';

export const BodyWrapper = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-items: top;
  width: 400px;
  margin-bottom: 20px;
  overflow-y: auto;
  justify-content: center;

  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          width: 100%;
        `;
      }
      default: {
        return "400px";
      }
    }
  }}
`;

export const CustomerElement = styled.div`
  border-radius: 2px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
  background-color: ${colors.backgroundInput};
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: start;
  grid-template-rows: 67px 1fr;
  margin: 5px 10px;
  padding: 10px;
  border-bottom: 2px solid;
  border-bottom-color: ${props => (props.$selected ? colors.primary : 'transparent')};
  cursor: pointer;
  opacity: ${props => (props.$disabled? '0.5' : '1')};

  &:hover {
    border-bottom-color: ${props => (props.$disabled? 'transparent' : colors.primary)};
  }
`;

export const Label = styled.div`
  padding: 0;
  margin: 0;
  justify-self: flex-start;
  font-family: Lato;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${colors.primary};
  :first-child {
    width: 100px;
    text-align: left;
  }
  :last-child {
    width: calc(100% - 100px);
    margin-left: 10px;
  }
`;